import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const Ellipse1802Icon = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" focusable="false" ref={ref} {...props}><circle id="Ellipse 1802" cx={8} cy={8} r={8} fill="#6184FF" /></svg>;
const ForwardRef = forwardRef(Ellipse1802Icon);
export default ForwardRef;